import { render } from "./dma.vue?vue&type=template&id=64e34b50&scoped=true"
import script from "./dma.vue?vue&type=script&lang=js"
export * from "./dma.vue?vue&type=script&lang=js"

import "./dma.vue?vue&type=style&index=0&id=64e34b50&lang=scss&scoped=true"

import exportComponent from "D:\\work\\zwkj\\cdzblue\\loginform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e34b50"]])

export default __exports__